<template>
	<li v-if="link && link.href" class="nav-link">
		<NuxtLinkLocale
			:to="link.href"
			class="link"
			:class="link.class"
			:icon-type="iconType"
			@click="pushTracking"
		>
			<SvgIcon
				v-if="icon"
				:icon="icon"
				color="black"
				class="svg-icon"
			></SvgIcon>
			{{ link.text }}

			<SvgIcon
				v-if="isExternalLink"
				icon="externalLink"
				color="black"
			></SvgIcon>
			<span class="link__tag" v-if="tag">{{ tag }}</span>
		</NuxtLinkLocale>
		<div v-if="link.title" class="link__subtitle">{{ link.title }}</div>
		<slot></slot>
	</li>
</template>

<script setup>
const { pushGa4 } = useTracking();
const props = defineProps({
	fields: { type: Object },
	rendering: { type: Object, required: false },
	iconType: { type: String, required: false, default: "light" },
});

const gtm = computed(() => props.fields?.gtm?.value);
const link = computed(() => props.fields?.link?.value);
const icon = computed(() => props.fields?.icon?.value);
const tag = computed(() => props.fields?.tag?.value);
const isExternalLink = computed(() => link?.value?.href?.startsWith("http"));

function pushTracking() {
	pushGa4(gtm.value);
}
</script>

<style lang="scss">
.nav-link {
	.link {
		font-size: var(--text-base, 16px);
		display: flex;
		align-items: center;
		gap: var(--spacing-1, 8px);
		color: var(--color-black, #000);
		text-decoration: none;
		padding: var(--spacing-105, 12px) var(--spacing-3, 24px);
		font-family: var(--primary-font, sans-serif);
		font-weight: 400;
		line-height: 1.4;

		.has-child & {
			font-weight: 400;
			font-size: var(--text-base, 16px);
		}

		.external-link-icon {
			height: auto !important;
		}

		.svg-icon {
			margin-bottom: 2px;
		}

		.link__tag {
			color: var(--Primary-Night-Sky, #191a1a);
			font-family: var(--primary-font, sans-serif);
			font-size: 11px;
			font-weight: 400;
			line-height: 1;
			text-transform: uppercase;
			display: inline-flex;
			padding: var(--spacing-05, 4px) var(--spacing-1, 8px);
			justify-content: center;
			align-items: center;
			border-radius: 2px;
			background: #2eac83;
			text-decoration: none;
			margin-left: 10px;
		}
	}

	.link__subtitle {
		font-size: var(--text-sm, 14px);
		font-weight: 400;
		line-height: 140%;
		color: var(--color-gray, #5c5c5c);
		padding: 0 var(--spacing-3, 24px);
	}

	&:has(.link__subtitle) .link {
		padding-bottom: var(--spacing-1, 8px);
	}
}
</style>
